import { AxiosError } from 'axios';
import { createContext, useContext } from 'react';
import { SimSelectionType } from '../../../../pages/ConfigureLine/types';

type ConfigureLineContextType = {
    blocked: boolean;
    blockedLines: string[];
    blockedLineSuccess: boolean;
    duplicateSimSuccess: boolean;
    configureLineError: AxiosError | null;
    isConvergent: boolean;
    simTypeSelected: SimSelectionType;
    blockedLinesChecked: boolean;
    lineActive: string;
    blockedLineRestrictionId: string;
    eSimInstallFlow: 'qr' | 'install';
    setBlockedLineSuccess: (value: boolean) => void;
    setBlockedLines: (value: string[]) => void;
    setDuplicateSimSuccess: (value: boolean) => void;
    setBlocked: (value: boolean) => void;
    setConfigureLineError: (value: AxiosError | null) => void;
    setIsConvergent: (value: boolean) => void;
    setSimTypeSelected: (value: SimSelectionType) => void;
    setBlockedLinesChecked: (value: boolean) => void;
    setLineActive: (value: string) => void;
    setBlockedLineRestrictionId: (value: string) => void;
    setESimInstallFlow: (value: 'qr' | 'install') => void;
};

export const ConfigureLineContext = createContext({} as ConfigureLineContextType);

export const useConfigureLineContext = () => {
    const context = useContext(ConfigureLineContext);

    if (!context) throw new Error('useConfigureLineContext must be used within a ConfigureLineProvider');

    return context;
};
